import { useSelector } from "react-redux"
import { RootState } from "../redux/store"

export type UserType = "client" | "driver"

export const useUserType = () => {
  const { userData } = useSelector((state: RootState) => state.auth)

  const getUserType = (): UserType => {
    if (userData && userData.accountDetails) {
      return "client"
    } else {
      return "driver"
    }
  }

  const userType = getUserType()

  return userType
}
